let accountQueryViaSormEnabled = false

/** Whether the legacy `account/query/` RTK endpoints read from SORM instead. */
export function isAccountQueryViaSormEnabled(): boolean {
  return accountQueryViaSormEnabled
}

export function setAccountQueryViaSormEnabled(enabled: boolean): void {
  accountQueryViaSormEnabled = enabled
}
